enum WorkspaceProjectUpdateStatus {
  Draft = 'Draft',
  Published = 'Published',
  Archived = 'Archived',
}

export default WorkspaceProjectUpdateStatus
